import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/events/courses/${resource.id}/edit`} />,
    <MenuItem primaryText='Facilitator' key='facilitator' value={`/security/users/${resource.facilitator_id}/edit`} />
  ]
}

export default buildMenuItems
